import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { loadUser } from "redux-oidc";

import { userManager } from "../../Utilities/userManager";
import { rootReducer } from "./rootReducer";
import { serverErrorsMiddleware } from "../Middleware";
import { successNotifier } from "../Middleware/Success/Success";

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunkMiddleware, serverErrorsMiddleware, successNotifier))
);

loadUser(store, userManager);

export { store };
